import { BaseApiResponse } from '../../types';
import { simpleQueryServerData } from '../simpleQueryServerData';

/**
 * Fetches information about actual system configuration
 */
export async function fetchNewMessagesCount(): Promise<BaseApiResponse<number | null>> {
    return simpleQueryServerData('api_react/src/menu/getNewMessagesCount.php');
}
